import { useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
import UserAddRegion from '../../UserAddRegion';
import UserAddJob from '../../UserAddJob';
import UserAddOccupation from '../../UserAddOccupation';
import UserAddCompany from '../../UserAddCompany';

const OnboardingStepWorkPrefs = ({
    formData,
    setFormData,
    errors,
    setFieldError,
}) => {
    const workPreferences = formData?.workPreferences || {};

    const handleWorkPreferencesChange = useCallback((eOrPatch) => {
        if (eOrPatch?.target?.name) {
            const { name, value, type, checked } = eOrPatch.target;
            const nextValue = type === 'checkbox' ? checked : value;

            setFormData(prev => {
                const next = {
                    ...prev,
                    workPreferences: {
                        ...(prev.workPreferences || {}),
                        [name]: nextValue,
                    },
                };
                return next;
            });

            return;
        }

        if (eOrPatch && typeof eOrPatch === 'object') {
            setFormData(prev => ({
                ...prev,
                workPreferences: {
                    ...(prev.workPreferences || {}),
                    ...eOrPatch,
                },
            }));
        }
    }, [setFormData]);

    const handleOccupationsChange = useCallback((occupations) => {
        handleWorkPreferencesChange({ occupations });
        setFieldError('occupationsList', null);
    }, [handleWorkPreferencesChange, setFieldError]);

    return (
        <>
            <Row className="my-3">
                <Col>
                    <h2>Work preferences</h2>
                </Col>
            </Row>

            <Row>
                <Col>
                    <UserAddRegion
                        formData={workPreferences}
                        handleChange={handleWorkPreferencesChange}
                        errors={errors}
                        isEditPage={false}
                        hideEdit={true}
                    />
                </Col>
            </Row>

            <Row>
                <Col>
                    <UserAddJob
                        formData={workPreferences}
                        handleChange={handleWorkPreferencesChange}
                        errors={errors}
                        isEditPage={false}
                        hideEdit={true}
                        isOnboarding
                    />
                </Col>
            </Row>

            <Row>
                <Col>
                    <UserAddOccupation
                        formData={workPreferences}
                        onOccupationsChange={handleOccupationsChange}
                        errors={errors}
                        isEditPage={false}
                        hideEdit={true}
                    />
                </Col>
            </Row>

            <Row>
                <Col>
                    <UserAddCompany
                        formData={workPreferences}
                        handleChange={handleWorkPreferencesChange}
                        isEditPage={false}
                        hideEdit={true}
                        isLastSection
                        requireCompanySize={false}
                    />
                </Col>
            </Row>
        </>
    );
};

export default OnboardingStepWorkPrefs;
